import React from "react";
import AlumniLine from "shared/Experimental/Icons/AlumniLine";
import AlumniFilled from "shared/Experimental/Icons/AlumniFilled";
import {useTranslation} from "@unibuddy/intl";
import {IconTab} from "../IconTab/IconTab";
import {IntlNamspaces} from "../../../../../translations/types";
import {INTL_ALUMNI} from "../../../../../translations/common";

export default function AlumniHeaderTab(props) {
    const {t} = useTranslation(IntlNamspaces.COMMON);

    return (
        <IconTab
            {...props}
            id="alumni"
            name={t(INTL_ALUMNI.key, INTL_ALUMNI.defaultValue)}
            onClick={props.onClick}
            to={props.to}
            icon={(isActive) => (isActive ? <AlumniFilled /> : <AlumniLine />)}
        />
    );
}
